export enum OrderingAtestadosEnum {
    MaisAntigo = 'Mais antigo',
    MaisRecente = 'Mais recente',
}